import { apiSelector } from '@ackee/redux-utils';

import { ApiReducerKey, EntityKey } from 'modules/entities/constants';
import type { RootState } from 'modules/core/modules/redux';

export const updateDeliveryRequestApiSelector = (state: RootState) =>
    apiSelector(state, EntityKey.DELIVERY_REQUESTS, ApiReducerKey.UPDATE);
